/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonNotification
 */
export interface JsonNotification {
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    cancelAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    errorMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    eventId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    failedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    inviteId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    notificationId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    notificationType?: JsonNotificationNotificationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    recipient?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    sentAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    status?: JsonNotificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonNotification
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonNotification
     */
    userId?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonNotificationNotificationTypeEnum {
    UserActivate = 'USER_ACTIVATE',
    UserRecover = 'USER_RECOVER',
    InviteGuest = 'INVITE_GUEST',
    InviteGuestReturn = 'INVITE_GUEST_RETURN',
    InviteGuestConfirm = 'INVITE_GUEST_CONFIRM',
    InviteGuestCancel = 'INVITE_GUEST_CANCEL',
    InviteOrg = 'INVITE_ORG',
    InviteOrgReturn = 'INVITE_ORG_RETURN',
    InviteOrgConfirm = 'INVITE_ORG_CONFIRM',
    InviteOrgCancel = 'INVITE_ORG_CANCEL',
    InviteSupp = 'INVITE_SUPP',
    InviteSuppReturn = 'INVITE_SUPP_RETURN',
    InviteSuppConfirm = 'INVITE_SUPP_CONFIRM',
    InviteSuppCancel = 'INVITE_SUPP_CANCEL',
    UpdateOrg = 'UPDATE_ORG',
    UpdateOrgReturn = 'UPDATE_ORG_RETURN',
    UpdateOrgConfirm = 'UPDATE_ORG_CONFIRM',
    UpdateOrgCancel = 'UPDATE_ORG_CANCEL',
    TravelOrg = 'TRAVEL_ORG',
    TravelOrgReturn = 'TRAVEL_ORG_RETURN',
    TravelOrgConfirm = 'TRAVEL_ORG_CONFIRM',
    TravelOrgCancel = 'TRAVEL_ORG_CANCEL',
    CompOrg = 'COMP_ORG',
    CompOrgReturn = 'COMP_ORG_RETURN',
    CompOrgConfirm = 'COMP_ORG_CONFIRM',
    CompOrgCancel = 'COMP_ORG_CANCEL',
    SafetyOrg = 'SAFETY_ORG',
    SafetyOrgCancel = 'SAFETY_ORG_CANCEL',
    EventGroupOrg = 'EVENT_GROUP_ORG',
    SiwiPrinted = 'SIWI_PRINTED'
}/**
* @export
* @enum {string}
*/
export enum JsonNotificationStatusEnum {
    Deleted = 'DELETED',
    Pending = 'PENDING',
    Sent = 'SENT',
    Skipped = 'SKIPPED',
    Failed = 'FAILED'
}

export function JsonNotificationFromJSON(json: any): JsonNotification {
    return JsonNotificationFromJSONTyped(json, false);
}

export function JsonNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'body': !exists(json, 'body') ? undefined : json['body'],
        'cancelAt': !exists(json, 'cancelAt') ? undefined : json['cancelAt'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'failedAt': !exists(json, 'failedAt') ? undefined : json['failedAt'],
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
        'notificationId': !exists(json, 'notificationId') ? undefined : json['notificationId'],
        'notificationType': !exists(json, 'notificationType') ? undefined : json['notificationType'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'recipient': !exists(json, 'recipient') ? undefined : json['recipient'],
        'sentAt': !exists(json, 'sentAt') ? undefined : json['sentAt'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JsonNotificationToJSON(value?: JsonNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'body': value.body,
        'cancelAt': value.cancelAt,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'errorMessage': value.errorMessage,
        'eventId': value.eventId,
        'failedAt': value.failedAt,
        'inviteId': value.inviteId,
        'notificationId': value.notificationId,
        'notificationType': value.notificationType,
        'partyId': value.partyId,
        'recipient': value.recipient,
        'sentAt': value.sentAt,
        'status': value.status,
        'subject': value.subject,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
    };
}

